:host {
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  display: flex;
  position: absolute;
  flex-direction: column;
  width: 100%;
  height: 100%;
  contain: layout size style;
  z-index: 0;
}

.tabs-inner {
  position: relative;
  flex: 1;
  contain: layout size style;
}